export default __webpack_public_path__ + "static/media/No40Open.fb132de4.jpg";